"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
function legendItemColor(H) {
    H.wrap(H.Legend.prototype, 'colorizeItem', function (proceed, item) {
        item.legendColor = item.options.legendColor;
        proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    });
}
exports.default = legendItemColor;
//# sourceMappingURL=legendItemColor.js.map